import { SpinnerWrapper, SpinnerCircle } from './Spinner.style';

export const Spinner: React.FC = () => {
  return (
    <SpinnerWrapper>
      <SpinnerCircle />
    </SpinnerWrapper>
  );
};
